import { render, staticRenderFns } from "./StepShipments.vue?vue&type=template&id=50f4dda8&scoped=true"
import script from "./StepShipments.vue?vue&type=script&lang=js"
export * from "./StepShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f4dda8",
  null
  
)

export default component.exports